export default function getPeriodDomainWidths(allPeriods, data) {
  const periodWidths = {};
  for (const period of allPeriods) {
    // get skill areas for this period
    let maxPeriodWidth = 0;
    for (const domain of data || []) {
      let domainPeriodWidth = 0;

      for (const skillArea of domain.progression) {
        if (skillArea.gradeLabel === period)
          domainPeriodWidth += skillArea.width;
      }

      if (domainPeriodWidth > maxPeriodWidth)
        maxPeriodWidth = domainPeriodWidth;
    }

    // skip if width is zero
    if (!maxPeriodWidth) continue;

    //+3 for borderRight/padding
    periodWidths[period] = Math.max(maxPeriodWidth + 6, 106);
  }
  return periodWidths;
}